import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Retail  = () => {

  const  servicesFaqData = [
    { 
        question: "What is retail printing, and what materials are included?     ", 
        answer: "Retail printing involves creating high-quality materials such as banners, posters, brochures, and point-of-sale displays to support retail marketing and branding efforts. It includes printing for showroom print collaterals that enhance the visual appeal of retail spaces and drive customer engagement. Retail printing also covers campaign promotional materials, such as flyers, window decals, and shelf tags. These materials are essential for effective product promotion, brand visibility, and customer communication in the retail sector."
    },
    { 
        question: "What are the benefits of printing for retail promotions?  ", 
        answer: "Printing for retail promotions provides visually engaging materials that attract customer attention and boost sales. Customised designs allow businesses to showcase offers, new products, and seasonal campaigns effectively. High-quality printing ensures vibrant colours and sharp details, making promotional materials stand out in a competitive environment. Durable materials ensure the printed items last throughout the promotion, maintaining a professional appearance. Retail promotional printing helps create a cohesive and impactful marketing strategy that resonates with customers."
    },
    { 
        question: "Can Printingy handle bulk orders for retail printing services?   ", 
        answer: "Yes, Printingy specialises in bulk retail printing services, offering cost-effective solutions for large-scale campaigns and store requirements. Bulk printing reduces per-unit costs, making it an economical option for retail businesses and marketing agencies. Our advanced technology ensures consistent quality across all materials, regardless of order size. We also provide quick turnaround times, ensuring that promotional materials are ready for timely deployment. Printingy’s reliable bulk printing services efficiently support the operational and marketing needs of retail businesses."
    },
    { 
        question: "What materials are used for showroom print collaterals?   ", 
        answer: "Our printing for showroom print collateral services use premium materials such as laminated paper, vinyl, and weather-resistant options. Laminated paper is ideal for posters and signage, providing a polished look and durability. Vinyl materials are perfect for banners and window decals, offering vibrant colours and long-lasting performance. Weather-resistant options are available for outdoor displays, ensuring materials remain intact in varying conditions. These materials are carefully selected to enhance retail collaterals' visual appeal and functionality."
    },
    { 
        question: "What industries and businesses benefit from retail printing services?  ", 
        answer: "Retail shops, showrooms, and marketing agencies benefit significantly from retail printing services. Retailers use printed materials for in-store branding, promotions, and customer engagement. Showrooms rely on collaterals to enhance their visual presentation and create a professional atmosphere. Marketing agencies utilise custom printing for creative campaigns and brand promotions. Whether for small shops or large retail chains, high-quality printing supports effective communication, enhances customer experience, and drives sales."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Retail');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Professional Retail Printing Services"
  description="High-quality printing services for retail shops and showrooms. Bulk printing for retail promotions, advertising, and customised print collaterals for retail businesses."
  keywords="Printing Services for Retail,
Printing for Retail Shops,
Printing for Showroom Print Collaterals,
Printing for Retail Promotions,
Retail Printing Services,
Advertising Retail Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Retail  </h1>
              <h2 className="text-muted">Customised printing solutions for retail shops, showrooms, and promotions</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Retail printing enhances customer engagement, promotes products, and builds brand visibility. Printingy specialises in retail printing services, providing high-quality retail printing tailored to meet the needs of shops and showrooms.</p>
          <p>Our offerings include printing for showroom print collaterals, such as posters, banners, and promotional materials that elevate your store’s aesthetic and marketing impact. For promotional campaigns, we deliver printing for retail promotions, ensuring vibrant visuals and durable materials. Our advertising retail printing services also support creative campaigns with customised designs that capture attention and drive sales.</p> 
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Retail Printing Solutions </h2>
                <h3 className="large-hed">High-quality, durable printing for retail shops, showrooms, and promotions </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing services for retail with tailored designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing for retail shops with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Comprehensive printing for showroom print collaterals to enhance store aesthetics.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional advertising retail printing for creative campaigns.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials ensure long-lasting results for promotional use.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals to showcase products and branding effectively.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for retail shops, showrooms, and marketing agencies.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/retailprints.jpg" // Path relative to the public folder
                  alt="High-quality printing services for retail businesses"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Retail Printing Delivered On Time </h2>
            <h3 className="small-hed">Focus on your retail operations while we handle your printing needs  </h3>
            <p>Printingy uses advanced printing technology and premium materials to deliver exceptional retail printing services. Our solutions ensure professional and impactful results, whether for showroom collaterals, promotional banners, or advertising materials.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing timely delivery for all bulk and customised orders. Partner with Printingy for reliable, innovative printing solutions that enhance your retail branding and promotions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Retail;
